import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import ListarUsuariosAll from '@/features/users/components/lista-user-all'
import CreateAllUsuario from '@/features/users/components/create-user-all'
import { useState } from 'react'
import { PageLayout } from '@/layouts'
import ListarUsuariosAllPagination from '@/features/users/components/lista-user-all-pagination'
import ListaUserAllFilter from '@/features/users/components/lista-user-all-filters'
import { useCurrentUser } from '@/features/auth/state/auth'

export default function UsersPage() {
  const [isUserModalOpen, setIsUserModalOpen] = useState(false)
  const user = useCurrentUser()
  return (
    <PageLayout
      title="Lista de Parceiros"
      description={
        <div className="flex flex-col md:flex-row justify-between gap-4 mb-4 w-full">
          <ListaUserAllFilter />
          {(user?.typeCargo === 'CEO' || user?.typeCargo === 'TI') && user?.typeUser === 'ADMIN' && (
            <Button className="w-full md:w-auto" onClick={() => setIsUserModalOpen(true)}>
              Criar Usuário
            </Button>
          )}
        </div>
      }
      footer={<ListarUsuariosAllPagination />}
    >
      <ListarUsuariosAll />

      <Dialog open={isUserModalOpen} onOpenChange={setIsUserModalOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Cadastro de usuário</DialogTitle>
          </DialogHeader>

          <div className="mt-8">
            <CreateAllUsuario />
          </div>
        </DialogContent>
      </Dialog>
    </PageLayout>
  )
}
